// Tool → canvas route map. Used by:
//   - useChat (chat.ts): auto-navigate the main pane when a primary-pane
//     envelope arrives, so the chart the agent rendered is actually on
//     screen instead of just a card in the right rail
//   - RightPinPane: pinned card click navigates to the matching view
//
// Tools that return single-entity property grids (get_task / get_risk /
// get_resource) deliberately have NO mapping — they stay in the right
// pin pane as detail; navigating away would defeat the purpose.

import type { Envelope } from "./envelope.js";

type RouteResolver = (env: Envelope) => string;

const TOOL_ROUTES: Record<string, RouteResolver> = {
  project_dashboard:         () => "/",
  critical_path_summary:     () => "/critical-path",
  render_critical_path:      (env) => {
    const m = (env.audit?.args?.["model"] as string) || "rcpm";
    return `/critical-path?model=${encodeURIComponent(m)}`;
  },
  render_gantt:              () => "/gantt",
  render_wbs:                () => "/wbs",
  render_earned_value:       () => "/earned-value",
  render_resource_diagram:   () => "/resources",
  render_dependency_network: () => "/dependency-network",
  get_canonical:             () => "/canonical",
  list_risks:                () => "/risk",
  list_tasks:                () => "/wbs",
  list_resources:            () => "/resources",
  project_diff:              () => "/canonical",
  verify_state:              () => "/ops",
  list_canonical_changes:    () => "/canonical",
};

/** Return the canvas route for the envelope's source tool, or null when no
 * mapping applies (single-entity detail tools fall here on purpose). */
export function envelopeRoute(env: Envelope): string | null {
  const tool = env.audit?.tool;
  if (!tool) return null;
  const r = TOOL_ROUTES[tool];
  return r ? r(env) : null;
}
